import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetMatingCowsAction, matingAction} from '../action';

const tableId = 'matingCows';

function* execute({payload: {tableDataRequest}}: GetMatingCowsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getFemaleHolsteinAnimalsInList,
        successAction: matingAction.getFemaleAnimalsSuccess,
        tableId,
    }));
}

/** Saga that handles `mating/GET_MATING_COWS`. */
export function* getMatingCowsSaga(): SagaIterator {
    yield takeLatestF('mating/GET_MATING_COWS', execute);
}
